import { useState, createContext, useContext, useMemo, useEffect, SetStateAction, Dispatch } from "react";
import IdentityManager from '@arcgis/core/identity/IdentityManager';
import config from "../config";

interface IAuth {
  token?: string;
  authInitialized: boolean;
  setAuthInitialized: Dispatch<SetStateAction<boolean>>
}

const AuthContext = createContext<IAuth>({ token: undefined, authInitialized: false, setAuthInitialized: () => {} });

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error("useAuthContext must be used within a AuthProvider");
  }
  return context;
}

interface IAuthContextProvider {
  children: React.ReactNode;
}

export function AuthContextProvider({ children }: IAuthContextProvider) {
  const [authInitialized, setAuthInitialized] = useState(false);
  const [token, setToken] = useState<string | undefined>(undefined);

  useEffect(() => {
    try {
      IdentityManager.registerToken({
        token: config.esriApiKey,
        server: process.env.REACT_APP_APP_TOKEN_BASE_URL!
      });
      setToken(config.esriApiKey);
      setAuthInitialized(true);
    } catch (error) {
      console.error(error);
    }

  }, [authInitialized]);

  const values = useMemo(() => ({
    token,
    authInitialized,
    setAuthInitialized,
  }), [token, authInitialized]);

  return (<AuthContext.Provider value={values}>{children}</AuthContext.Provider>);
}